import axiosInstance from '../../config';
import React, { useEffect, useState } from 'react';
import CurrencyFormat from 'react-currency-format';
import '../../styles/styles.css';
import { useHistory } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Navbar from '../../components/Navbar';
import BetList from '../../components/BetList';
import WegaBetList from '../../components/WegaBetList';
import ReportGrandTotal from '../../components/ReportGrandTotal';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { KeyboardReturnOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  pointer: {
    cursor: 'pointer',
  },
}));

const Summary = ({ User }) => {
  const classes = useStyles();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [reports, setReports] = useState([]);
  const [sumWager, setSumWager] = useState(0);
  const [sumTurnover, setSumTurnover] = useState(0);
  const [sumValid, setSumValid] = useState(0);
  const [sumWlCompany, setSumWlCompany] = useState(0);
  const [sumCommCompany, setSumCommCompany] = useState(0);
  const [sumCommGross, setSumCommGross] = useState(0);
  const [searchDate, setSearchDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const [bets, setBets] = useState([]);
  const [detailType, setDetailType] = useState(null);
  // Which book drew the line the drill-down was opened from - the read stamps it on every type row, and the
  // sports leg stamps nothing. A WeGa line's rows are in a different source from a sports line's, and the
  // line's own code cannot say which (a game id is free-form), so the drill-down below picks its reader from
  // this token: the sports lines keep the match report, a WeGa line opens the WeGa rows its figure counted
  // (Andrew, 2026-10-07).
  const [detailSource, setDetailSource] = useState(null);
  const [matchId, setMatchId] = useState(null);
  const [totalPage, setTotalPage] = useState(null);
  const [playerWager, setPlayerWager] = useState(0);
  const [playerWinning, setPlayerWinning] = useState(0);
  const [playerTurnover, setPlayerTurnover] = useState(0);
  const [playerComm, setPlayerComm] = useState(0);
  const [producers , setProducers] = useState();
  const [producerPubId , setProducerPubId] = useState(null);
  // The provider split (Andrew, 2026-09-24): a28i is our own book, WeGa the WeGa book, All the two
  // together. Default All - the complete company figure - and the read names it, so the figure and the
  // server agree on which legs were counted.
  const [source, setSource] = useState('ALL');
  // The drill-down's row sets. A Company Summary figure can cover three populations, so the list beneath it
  // has to be able to account for the money shown: the sports rows (BetList), the WeGa sports rows and the
  // games rows (both WegaBetList, the shape those two readers answer in). They are read together with the
  // member's list rather than on a tab click, so a tab never shows an empty count for a member who has rows.
  const [segment, setSegment] = useState('SPORT');
  const [betCount, setBetCount] = useState(0);
  const [wegaSportBets, setWegaSportBets] = useState([]);
  const [wegaSportCount, setWegaSportCount] = useState(0);
  const [wegaSportTotalPage, setWegaSportTotalPage] = useState(0);
  const [wegaSportAmount, setWegaSportAmount] = useState(0);
  const [wegaSportTurnover, setWegaSportTurnover] = useState(0);
  const [wegaSportWinning, setWegaSportWinning] = useState(0);
  const [wegaSportComm, setWegaSportComm] = useState(0);
  const [wegaBets, setWegaBets] = useState([]);
  const [wegaCount, setWegaCount] = useState(0);
  const [wegaTotalPage, setWegaTotalPage] = useState(0);
  const [wegaAmount, setWegaAmount] = useState(0);
  const [wegaTurnover, setWegaTurnover] = useState(0);
  const [wegaWinning, setWegaWinning] = useState(0);
  const [wegaComm, setWegaComm] = useState(0);
  // The period total behind the member the drill-down was opened from, per population and together - the
  // same block, from the same reader, the W/L Detail screen puts above its segments, so the two screens
  // show a total on one basis. Read once with the rows, so it cannot move as the segment changes.
  const [grandTotal, setGrandTotal] = useState(null);
  const [validDateRange , setValidDateRange] = useState(true)

  const history = useHistory();
  const calculateSum = (report) => {
    let wager = 0;
    let turnover = 0;
    let valid = 0;
    let wlCompany = 0,
      commCompany = 0,
      commGross = 0;

    for (var i = 0; i < report.length; i++) {
      wager += report[i].wager;
      turnover += report[i].amount;
      valid += report[i].turnover;
      if (report[i].companyWin) wlCompany += report[i].companyWin;
      if (report[i].companyCom) commCompany += report[i].companyCom;
      if (report[i].grossCom) commGross += report[i].grossCom;
    }
    setSumWager(wager);
    setSumTurnover(turnover);
    setSumValid(valid);
    setSumWlCompany(wlCompany);
    setSumCommCompany(commCompany);
    setSumCommGross(commGross);
  };

  const calculateBet = (report) => {
    let wager = 0;
    let turnover = 0;
    let comm = 0;
    let winning = 0;
    for (var i = 0; i < report.length; i++) {
      wager += report[i].amount;
      if (report[i].winning) winning += report[i].winning;
      turnover += report[i].turnover;
      comm += report[i].commission;
    }
    setPlayerWager(wager);
    setPlayerWinning(winning + comm);
    setPlayerTurnover(turnover);
    setPlayerComm(comm);
  };

  const viewDetail = (e, value) => {
    if (e != null) e.preventDefault();
    if (search === 'type' && matchId == null) {
      if (wegaTypeLine) {
        // A WeGa line: list the rows the figure above it counted, with the reader and the columns the Games
        // Report's own type drill-down uses. The match report below would answer with nothing for it - a
        // games bet carries no match, and neither a game id nor a sport code is a game_types code - which is
        // the empty table this branch exists to replace (Andrew, 2026-10-07). The two readers are cleared
        // first so the other population's rows cannot stand under this line while it loads.
        setWegaBets([]);
        setWegaCount(0);
        setWegaTotalPage(0);
        setWegaSportBets([]);
        setWegaSportCount(0);
        setWegaSportTotalPage(0);
        handleWegaChange(detailSource)(null, value);
        return;
      }
      let typeUrl = 'agent/companySummaryMatch';
      axiosInstance
        .get(typeUrl, {
          params: {
            username: null,
            startDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
            endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
            type: detailType,
            wc: true,
            pageNo: isNaN(value) ? null : value - 1,
            mtc:
              document.getElementById('matchDateCb') &&
              document.getElementById('matchDateCb').checked
                ? 'Y'
                : 'N',
            gameCategoryFilter: document.getElementById('gmStsFilter')
              ? document.getElementById('gmStsFilter').value
              : '',
            coOnly: true,
            searchProducerPubId : producerPubId ? producerPubId : null
          },
        })
        .then((res) => {
          setReports(res.data.content);
          calculateSum(res.data.content);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            history.push('/');
          }
        });
    } else {
      axiosInstance
        .get('agent/wlDetails/bets', {
          params: {
            username: matchId != null ? 'COMPANY' : detailType,
            startDate: startDate
              ? moment(startDate).format('DD-MM-YYYY')
              : null,
            endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
            wc: true,
            pageNo: isNaN(value) ? null : value - 1,
            mtc:
              document.getElementById('matchDateCb') &&
              document.getElementById('matchDateCb').checked
                ? 'Y'
                : 'N',
            matchId: matchId,
            game: matchId != null ? detailType : null,
            gameCategoryFilter: document.getElementById('gmStsFilter')
              ? document.getElementById('gmStsFilter').value
              : '',
            searchPlayer: document.getElementById('username')
              ? document.getElementById('username').value
              : null,
            searchWinLose: document.getElementById('resultvalue')
              ? document.getElementById('resultvalue').value
              : null,
            searchProducerPubId : producerPubId ? producerPubId : null
          },
        })
        .then((res) => {
          setBets(res.data.content);
          calculateBet(res.data.content);
          setTotalPage(res.data.totalPages);
          setBetCount(res.data.totalElements);
          // the WeGa row sets belong to this member's list, so they are read with it - and only when the
          // selected source can contain them. Never on the match-report path: that render has no WeGa rows.
          if (matchId == null) {
            // the total covers every leg of the member's period, whichever source the figure above was read
            // on: the lines are named, and they add up (Sports + WeGa sport = Sports Total, + Games = Grand
            // Total), so the block is the breakdown rather than a second, competing figure
            fetchGrandTotal(detailType, startDate, endDate);
          }
          if (matchId == null && source !== 'A28I') {
            if (sourceContains('WEGA_SPORT')) fetchWegaSports(detailType, startDate, endDate, null);
            else {
              setWegaSportBets([]);
              setWegaSportCount(0);
            }
            if (sourceContains('GAMES')) fetchWegaGames(detailType, startDate, endDate, null);
            else {
              setWegaBets([]);
              setWegaCount(0);
            }
          } else if (matchId == null) {
            setWegaSportBets([]);
            setWegaSportCount(0);
            setWegaBets([]);
            setWegaCount(0);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            history.push('/');
          }
        });
    }
  };

  // The WeGa row sets' footers, on the basis WegaBetList and the balance report's games segment use: a WeGa
  // row carries the stake in amount and the turnover in validTurnover, and the net is winning plus commission.
  const calculateWegaSport = (report) => {
    let amount = 0;
    let turnover = 0;
    let winning = 0;
    let comm = 0;
    for (let i = 0; i < report.length; i++) {
      amount += report[i].amount || 0;
      turnover += report[i].validTurnover || 0;
      if (report[i].winning) winning += report[i].winning;
      if (report[i].commission) comm += report[i].commission;
    }
    setWegaSportAmount(amount);
    setWegaSportTurnover(turnover);
    setWegaSportWinning(winning);
    setWegaSportComm(comm);
  };

  const calculateWega = (report) => {
    let amount = 0;
    let turnover = 0;
    let winning = 0;
    let comm = 0;
    for (let i = 0; i < report.length; i++) {
      amount += report[i].amount || 0;
      turnover += report[i].validTurnover || 0;
      if (report[i].winning) winning += report[i].winning;
      if (report[i].commission) comm += report[i].commission;
    }
    setWegaAmount(amount);
    setWegaTurnover(turnover);
    setWegaWinning(winning);
    setWegaComm(comm);
  };

  // The two WeGa row sets of one member. Each reader pages and totals its own rows, and the member is named
  // the way the sports read above names it, so a request that names nobody resolves on the backend rather
  // than narrowing to a session username that carries a sub-agent suffix. The same two reads serve the
  // report-by-type drill-down, where the scope is the whole book and `game` carries the line's own code
  // instead of a member: one reader per population, whichever screen asks.
  const fetchWegaSports = (member, from, to, page, game) => {
    axiosInstance
      .get('agent/wlDetails/wegaSport', {
        params: {
          username: member ? member : null,
          startDate: from ? moment(from).format('DD-MM-YYYY') : null,
          endDate: to ? moment(to).format('DD-MM-YYYY') : null,
          game: game ? game : null,
          pageNo: page,
        },
      })
      .then((res) => {
        setWegaSportBets(res.data.content);
        setWegaSportCount(res.data.totalElements);
        setWegaSportTotalPage(res.data.totalPages);
        calculateWegaSport(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
        // a failed read must not leave the previous member's rows standing under this member's name
        setWegaSportBets([]);
        setWegaSportCount(0);
        setWegaSportTotalPage(0);
      });
  };

  const fetchWegaGames = (member, from, to, page, game) => {
    axiosInstance
      .get('agent/wlDetails/wega', {
        params: {
          username: member ? member : null,
          startDate: from ? moment(from).format('DD-MM-YYYY') : null,
          endDate: to ? moment(to).format('DD-MM-YYYY') : null,
          game: game ? game : null,
          pageNo: page,
        },
      })
      .then((res) => {
        setWegaBets(res.data.content);
        setWegaCount(res.data.totalElements);
        setWegaTotalPage(res.data.totalPages);
        calculateWega(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
        setWegaBets([]);
        setWegaCount(0);
        setWegaTotalPage(0);
      });
  };

  // Which populations the selected source can contain, so the tabs match the figure above them: a28i has
  // own-sports rows only, WeGa the two WeGa sets, All all three, and a half of WeGa exactly one of them
  // (Andrew, 2026-10-04).
  const segmentsFor = () => {
    if (source === 'A28I') return [{ key: 'SPORT', label: 'Sports', count: betCount }];
    if (source === 'WEGA_SPORT')
      return [{ key: 'WEGA_SPORT', label: 'WeGa sport', count: wegaSportCount }];
    if (source === 'WEGA_GAMES') return [{ key: 'GAMES', label: 'Games', count: wegaCount }];
    if (source === 'WEGA')
      return [
        { key: 'WEGA_SPORT', label: 'WeGa sport', count: wegaSportCount },
        { key: 'GAMES', label: 'Games', count: wegaCount },
      ];
    return [
      { key: 'SPORT', label: 'Sports', count: betCount },
      { key: 'WEGA_SPORT', label: 'WeGa sport', count: wegaSportCount },
      { key: 'GAMES', label: 'Games', count: wegaCount },
    ];
  };

  // The same rule, asked of one row set: the WeGa sets are read only when the source is made of them, so a
  // set the figure excludes is never fetched - the tabs hide an empty set, and a fetched set the source
  // cannot contain would put a tab on screen the figure beside it does not account for.
  const sourceContains = (which) => {
    if (source === 'A28I') return false;
    if (source === 'WEGA_SPORT') return which === 'WEGA_SPORT';
    if (source === 'WEGA_GAMES') return which === 'GAMES';
    return true;
  };

  const fetchGrandTotal = (member, from, to) => {
    axiosInstance
      .get('agent/wlDetails/grandTotal', {
        params: {
          // the same value the row reads beside this one send: the backend resolves a request that names
          // nobody to the caller, so a session username here would scope the total to a prefix no member has
          username: member ? member : null,
          startDate: from ? moment(from).format('DD-MM-YYYY') : null,
          endDate: to ? moment(to).format('DD-MM-YYYY') : null,
          wc: true,
          searchProducerPubId: producerPubId ? producerPubId : null,
        },
      })
      .then((res) => {
        setGrandTotal(res.data);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
        // same rule as the rows: a failed read clears the block rather than leaving the last one up
        setGrandTotal(null);
      });
  };

  // Tabs with no rows are hidden (the balance report's rule), so the list shown follows the tabs that
  // remain - otherwise a member whose money is games-only would open to an empty WeGa sports list.
  const visibleSegments = segmentsFor().filter((s) => s.count !== 0);
  const shownSegment =
    visibleSegments.length === 1 ? visibleSegments[0].key : segment;

  // Report by type: the opened line is a type line, and the read stamped the book it came from on it. A WeGa
  // line's rows live in the WeGa readers; a sports line's in the match report. Nothing else on this screen
  // reads this - the member drill-down knows its population from the source selector above it.
  const wegaTypeLine = detailSource === 'GAMES' || detailSource === 'WEGA_SPORT';

  // A member's rows are scoped by the member (detailType carries their code); a type line's rows are the whole
  // book narrowed to that line, so there the same variable is the game filter and the scope names nobody -
  // which the backend resolves to the caller, exactly as the sports read beside it does.
  const handleWegaChange = (which) => (e, value) => {
    if (e != null) e.preventDefault();
    const page = isNaN(value) ? null : value - 1;
    if (wegaTypeLine) {
      if (which === 'WEGA_SPORT') fetchWegaSports(null, startDate, endDate, page, detailType);
      else fetchWegaGames(null, startDate, endDate, page, detailType);
      return;
    }
    if (which === 'WEGA_SPORT') fetchWegaSports(detailType, startDate, endDate, page);
    else fetchWegaGames(detailType, startDate, endDate, page);
  };

  const handleChange = (e, value) => {
    if (e != null) e.preventDefault();
    if (matchId != null) {
      viewDetail(e, value);
      return;
    }
    if (detailType != null) {
      viewDetail(e, value);
      return;
    }
    setReports([]);
    if (startDate == null && endDate == null) return;
    setLoading(true);
    let url = 'agent/companySummary';
    if (document.getElementById('searchType').value == 'type') {
      url = 'agent/companySummaryType';
      setSearch('type');
    } else {
      setSearch(null);
    }
    axiosInstance
      .get(url, {
        params: {
          startDate: startDate ? moment(startDate).format('DD-MM-YYYY') : null,
          endDate: endDate ? moment(endDate).format('DD-MM-YYYY') : null,
          mtc: document.getElementById('matchDateCb').checked ? 'Y' : 'N',
          gameCategoryFilter: document.getElementById('gmStsFilter')
            ? document.getElementById('gmStsFilter').value
            : '',
          source: source,
          searchProducerPubId : producerPubId ? producerPubId : null
        },
      })
      .then((res) => {
        setReports(res.data.content);
        calculateSum(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          history.push('/');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getToday = (minus) => {
    axiosInstance.get('public/today').then((res) => {
      setStartDate(null);
      setEndDate(null);
      let today = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      today.setDate(today.getDate() - minus);
      setStartDate(today);
      setEndDate(today);
      setMaxDate(
        new Date(
          res.data.substring(6),
          parseInt(res.data.substr(3, 2)) - 1,
          res.data.substring(0, 2)
        )
      );
      let minSearchDate = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      minSearchDate.setDate(minSearchDate.getDate() - 90);
      setSearchDate(minSearchDate);
    });
  };

  const getWeek = (minus) => {
    axiosInstance.get('public/today').then((res) => {
      setStartDate(null);
      setEndDate(null);
      let today = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      let today2 = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      let diff = today.getDay() - 1;
      if (diff < 0) diff += 7;
      today.setDate(today.getDate() - diff);
      if (minus > 0) {
        today.setTime(today.getTime() - minus * 7 * 24 * 60 * 60 * 1000);
        today2.setTime(today.getTime() + 6 * 24 * 60 * 60 * 1000);
      }
      setStartDate(today);
      setEndDate(today2);
      setMaxDate(
        new Date(
          res.data.substring(6),
          parseInt(res.data.substr(3, 2)) - 1,
          res.data.substring(0, 2)
        )
      );
      let minSearchDate = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      minSearchDate.setDate(minSearchDate.getDate() - 90);
      setSearchDate(minSearchDate);
    });
  };

  const getMonth = (minus) => {
    axiosInstance.get('public/today').then((res) => {
      setStartDate(null);
      setEndDate(null);
      let today = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      let today2 = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      if (minus > 0) {
        today.setMonth(today.getMonth() - minus);
        if (minus > 1) today2.setMonth(today2.getMonth() - minus + 1);
        today2.setDate(minus - 1);
      }
      today.setDate(1);
      setStartDate(today);
      setEndDate(today2);
      setMaxDate(
        new Date(
          res.data.substring(6),
          parseInt(res.data.substr(3, 2)) - 1,
          res.data.substring(0, 2)
        )
      );
      let minSearchDate = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      minSearchDate.setDate(minSearchDate.getDate() - 90);
      setSearchDate(minSearchDate);
    });
  };

  const generateRow = (wl, com) => {
    return (
      <>
        {wl != null ? (
          <td className={`text-right${wl < 0 ? ' text-danger' : ''}`}>
            <CurrencyFormat
              value={wl}
              decimalScale={2}
              displayType={'text'}
              thousandSeparator={true}
              fixedDecimalScale={true}
            />
          </td>
        ) : null}
        {com != null ? (
          <td className={`text-right${com < 0 ? ' text-danger' : ''}`}>
            <CurrencyFormat
              value={com}
              decimalScale={2}
              displayType={'text'}
              thousandSeparator={true}
              fixedDecimalScale={true}
            />
          </td>
        ) : null}
        <td className={`text-right${wl + com < 0 ? ' text-danger' : ''}`}>
          <CurrencyFormat
            value={wl + com}
            decimalScale={2}
            displayType={'text'}
            thousandSeparator={true}
            fixedDecimalScale={true}
          />
        </td>
      </>
    );
  };
  const backToParent = () => {
    setBets([]);
    setPlayerComm(0);
    setPlayerTurnover(0);
    setPlayerTurnover(0);
    setPlayerWinning(0);
    if (matchId != null) setMatchId(null);
    else {
      setDetailType(null);
      // the token goes with the code it describes, or the next line opened from the list would be routed by
      // the previous one's book
      setDetailSource(null);
    }
  };

  const moneyTd = (amt) => {
    return (
      <td className={`text-right${amt < 0 ? ' text-danger' : ''}`}>
        <CurrencyFormat
          value={amt}
          decimalScale={2}
          displayType={'text'}
          thousandSeparator={true}
          fixedDecimalScale={true}
        />
      </td>
    );
  };
  useEffect(() => {
    if (startDate != null && endDate != null && endDate >= startDate)
      handleChange(null);
  }, [startDate, endDate, detailType, matchId, producerPubId, source]);

  useEffect(() => {
    axiosInstance.get('agent/selectProducer').then(res => {
      setProducers(res.data)
    })
  } , [])

  useEffect(() => {
    axiosInstance.get('public/today').then((res) => {
      let today = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      let today2 = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      today.setDate(1);
      setStartDate(today);
      setEndDate(today2);
      setMaxDate(
        new Date(
          res.data.substring(6),
          parseInt(res.data.substr(3, 2)) - 1,
          res.data.substring(0, 2)
        )
      );
      let minSearchDate = new Date(
        res.data.substring(6),
        parseInt(res.data.substr(3, 2)) - 1,
        res.data.substring(0, 2)
      );
      minSearchDate.setDate(minSearchDate.getDate() - 90);
      setSearchDate(minSearchDate);
    });
    handleChange(null);
  }, [history.location]);
  return (
    <>
      <Navbar User={User} />
      <div className="d-flex justify-content-between my-3 px-3 align-items-center ">
        <form action="" onSubmit={(e) => e.preventDefault()} id="form">
          Start Date:
          <DatePicker
            selected={startDate ? startDate : new Date()}
            minDate={searchDate}
            onChange={(date) => {
              if (date < new Date('2023-09-01')) {
                setValidDateRange(false);
                setProducerPubId('');
                setStartDate(date);
              } else {
                setValidDateRange(true);
                setStartDate(date);
              }
            }}
            className="mx-2"
            dateFormat="d MMM yyyy"
            disabled={search === 'type' && detailType != null}
          />
          End Date:
          <DatePicker
            selected={endDate ? endDate : new Date()}
            onChange={(date) => setEndDate(date)}
            className="mx-2"
            dateFormat="d MMM yyyy"
            minDate={startDate}
            maxDate={maxDate}
          />

          {producers && validDateRange && (
            <>
              <label htmlFor="producer">Producer : </label>
              <select
                name="producer"
                id="producerPubId"
                className="mx-2"
                onChange={(e) => {
                  console.log(e.target.value);
                  setProducerPubId(e.target.value);
                }}
              >
                <option value="" key={1}>
                  ALL
                </option>
                {producers.map((producer, index) => (
                  <>
                    <option value={producer.key} key={producer.key}>
                      {producer.val}
                    </option>
                  </>
                ))}
              </select>
            </>
          )}

          {/* The provider split. A select rather than the report family's segment buttons, because this
              screen's rows are one table read one way - the split chooses which legs that read covers, not
              which list is on screen. */}
          <label htmlFor="source">Source : </label>
          <select
            name="source"
            id="source"
            className="mx-2"
            value={source}
            onChange={(e) => {
              setSource(e.target.value);
              // the tabs follow the figure: a28i has no WeGa rows, WeGa has no own-sports rows, a half of
              // WeGa has exactly one tab, and All opens on the sports one
              setSegment(
                e.target.value === 'WEGA_GAMES'
                  ? 'GAMES'
                  : e.target.value === 'WEGA' || e.target.value === 'WEGA_SPORT'
                  ? 'WEGA_SPORT'
                  : 'SPORT'
              );
            }}
          >
            <option value="A28I" key="A28I">
              a28i
            </option>
            <option value="WEGA" key="WEGA">
              WeGa
            </option>
            <option value="WEGA_SPORT" key="WEGA_SPORT">
              WeGa Sport
            </option>
            <option value="WEGA_GAMES" key="WEGA_GAMES">
              WeGa Games
            </option>
            <option value="ALL" key="ALL">
              All
            </option>
          </select>

          <input
            type="checkbox"
            id="matchDateCb"
            onChange={() => {
              handleChange(null);
            }}
          />
          Match Date&nbsp;
          <select
            name="searchType"
            id="searchType"
            onChange={() => handleChange(null)}
          >
            <option value="report">Report</option>
            <option value="type">Type</option>
          </select>
          &nbsp;
          {search === 'type' ? (
            <>
              <select
                name="gmStsFilter"
                id="gmStsFilter"
                onChange={() => handleChange(null)}
              >
                <option value="ALL">All</option>
                <option value="RUNNING">Running</option>
                <option value="NONRUNNINGPARLAY">Non-Running</option>
                <option value="NONRUNNING">Today/Early Single</option>
                <option value="PARLAY">Parlay/All Up</option>
              </select>
              &nbsp;
            </>
          ) : null}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              handleChange(null);
            }}
          >
            Get Report
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getToday(0);
            }}
          >
            Today
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getToday(1);
            }}
          >
            Yesterday
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getWeek(0);
            }}
          >
            This Week
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getWeek(1);
            }}
          >
            Last Week
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getMonth(0);
            }}
          >
            This Month
          </button>{' '}
          <button
            className="btn btn-sm btn-primary px-1 py-1"
            onClick={() => {
              getMonth(1);
            }}
          >
            Last Month
          </button>{' '}
          {loading ? (
            <>
              <br />
              <img
                src={require('../../img/loadingAnimation.gif')}
                height={13}
                width={208}
                alt=""
              />
            </>
          ) : null}
        </form>
      </div>
      {detailType != null ? (
        <>
          <div className="table-responsive-sm mx-2">
            <button
              className="btn btn-sm btn-primary px-1 py-1 my-2"
              onClick={() => {
                backToParent();
              }}
            >
              Return
            </button>
          </div>

          <div className="table-responsive-sm mx-2">
            {search !== 'type' || matchId != null ? (
              <>
                {/* The figure above can cover three populations, so the list beneath it says which one it is
                    showing. A tab that would be empty is not offered, and a source whose rows are all in one
                    population gets no bar at all. */}
                <ReportGrandTotal total={grandTotal} />
                {visibleSegments.length > 1 ? (
                  <div className="segment-toggle">
                    {/* the same control the W/L Detail and the balance report's drill-down wear, so the
                        three screens read the same way */}
                    {visibleSegments.map((s) => (
                      <button
                        type="button"
                        key={s.key}
                        className={shownSegment === s.key ? 'active' : ''}
                        onClick={() => setSegment(s.key)}
                      >
                        {s.label} ({s.count})
                      </button>
                    ))}
                  </div>
                ) : null}
                {shownSegment === 'SPORT' ? (
                  <BetList
                    username={User.username}
                    startDate={startDate}
                    endDate={endDate}
                    matchId={matchId}
                    detailType={detailType}
                    bets={bets}
                    viewDetail={viewDetail}
                    handleChange={handleChange}
                    playerWager={playerWager}
                    playerWinning={playerWinning}
                    totalComm={playerComm}
                    totalTurnover={playerTurnover}
                    totalPage={totalPage}
                    agent={'Y'}
                    type={''}
                    producerPubId={producerPubId}
                  />
                ) : shownSegment === 'WEGA_SPORT' ? (
                  <WegaBetList
                    bets={wegaSportBets}
                    handleChange={handleWegaChange('WEGA_SPORT')}
                    totalPage={wegaSportTotalPage}
                    amountTotal={wegaSportAmount}
                    turnoverTotal={wegaSportTurnover}
                    commissionTotal={wegaSportComm}
                    winningTotal={wegaSportWinning}
                    tradeDetailUrl="agent/wega/tradeDetail"
                  />
                ) : (
                  <WegaBetList
                    bets={wegaBets}
                    handleChange={handleWegaChange('GAMES')}
                    totalPage={wegaTotalPage}
                    amountTotal={wegaAmount}
                    turnoverTotal={wegaTurnover}
                    commissionTotal={wegaComm}
                    winningTotal={wegaWinning}
                    tradeDetailUrl="agent/wega/tradeDetail"
                  />
                )}
              </>
            ) : wegaTypeLine ? (
              // A WeGa type line: the rows its own figure counted, in the listing the Games Report shows them
              // in (the same reader and columns its type drill-down uses). Its reader is the population the
              // line came from, so a games line never opens the WeGa-sports list and the other way round.
              <WegaBetList
                bets={detailSource === 'GAMES' ? wegaBets : wegaSportBets}
                handleChange={handleWegaChange(detailSource)}
                totalPage={detailSource === 'GAMES' ? wegaTotalPage : wegaSportTotalPage}
                amountTotal={detailSource === 'GAMES' ? wegaAmount : wegaSportAmount}
                turnoverTotal={detailSource === 'GAMES' ? wegaTurnover : wegaSportTurnover}
                commissionTotal={detailSource === 'GAMES' ? wegaComm : wegaSportComm}
                winningTotal={detailSource === 'GAMES' ? wegaWinning : wegaSportWinning}
                tradeDetailUrl="agent/wega/tradeDetail"
              />
            ) : (
              <table className="table table-sm table-striped table-bordered">
                <thead className="text-center thead-dark">
                  <tr>
                    <th scope="col" colSpan={9}>
                      Company Summary Match Report [
                      {moment(endDate).format('DD/MMM/YYYY')}]
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">Login ID / Type</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Wager</th>
                    <th scope="col">Turn Over</th>
                    <th scope="col">Valid Turn Over</th>
                    <th scope="col">Gross Comm</th>
                    <th scope="col">Win/Lose</th>
                    <th scope="col">Comm</th>
                    <th scope="col">Total W/L</th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((info, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <a
                          className={`${classes.pointer} text-primary p-0`}
                          onClick={() => {
                            setMatchId(info.code);
                          }}
                        >
                          {info.name !== '' ? info.name : info.username}
                        </a>
                      </td>
                      <td className="text-center">{info.currency}</td>
                      <td className="text-center">{info.wager}</td>
                      <td
                        className={`text-right${
                          info.amount < 0 ? ' text-danger' : ''
                        }`}
                      >
                        <CurrencyFormat
                          value={info.amount}
                          decimalScale={2}
                          displayType={'text'}
                          thousandSeparator={true}
                          fixedDecimalScale={true}
                        />
                      </td>
                      {moneyTd(info.turnover)}
                      {moneyTd(info.grossCom)}
                      {moneyTd(info.companyWin)}
                      {moneyTd(info.companyCom)}
                      {moneyTd(info.companyWin + info.companyCom)}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="font-weight-bold">
                    <td className="text-center" colSpan="2">
                      Total
                    </td>
                    <td className={`text-center`}>{sumWager}</td>
                    {moneyTd(sumTurnover)}
                    {moneyTd(sumValid)}
                    {moneyTd(sumCommGross)}
                    {generateRow(sumWlCompany, sumCommCompany)}
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
        </>
      ) : (
        <div className="table-responsive-sm mx-2">
          <table className="table table-sm table-striped table-bordered">
            <thead className="text-center thead-dark">
              <tr>
                <th scope="col" colSpan={9}>
                  Company Summary Report [
                  {moment(startDate).format('DD/MMM/YYYY') +
                    ' - ' +
                    moment(endDate).format('DD/MMM/YYYY')}
                  ]
                </th>
              </tr>
              <tr>
                <th scope="col">Login ID / Type</th>
                <th scope="col">Currency</th>
                <th scope="col">Wager</th>
                <th scope="col">Turn Over</th>
                <th scope="col">Valid Turn Over</th>
                <th scope="col">Gross Comm</th>
                <th scope="col">Win/Lose</th>
                <th scope="col">Comm</th>
                <th scope="col">Total W/L</th>
              </tr>
            </thead>
            {reports.length > 0 ? (
              <>
                <tbody>
                  {reports.map((info, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        {info.code === 'PARLAY' ? (
                          info.name !== '' ? (
                            info.name
                          ) : (
                            info.username
                          )
                        ) : (
                          <a
                            className={`${classes.pointer} text-primary p-0`}
                            onClick={() => {
                              setDetailType(info.code);
                              // the book the read drew this line from, which decides its drill-down below
                              setDetailSource(info.source ? info.source : null);
                            }}
                          >
                            {info.name !== '' ? info.name : info.username}
                          </a>
                        )}
                      </td>
                      <td className="text-center">{info.currency}</td>
                      <td className="text-center">{info.wager}</td>
                      <td
                        className={`text-right${
                          info.amount < 0 ? ' text-danger' : ''
                        }`}
                      >
                        <CurrencyFormat
                          value={info.amount}
                          decimalScale={2}
                          displayType={'text'}
                          thousandSeparator={true}
                          fixedDecimalScale={true}
                        />
                      </td>
                      {moneyTd(info.turnover)}
                      {moneyTd(info.grossCom)}
                      {moneyTd(info.companyWin)}
                      {moneyTd(info.companyCom)}
                      {moneyTd(info.companyWin + info.companyCom)}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="font-weight-bold">
                    <td className="text-center" colSpan="2">
                      Total
                    </td>
                    <td className={`text-center`}>{sumWager}</td>
                    {moneyTd(sumTurnover)}
                    {moneyTd(sumValid)}
                    {moneyTd(sumCommGross)}
                    {generateRow(sumWlCompany, sumCommCompany)}
                  </tr>
                </tfoot>
              </>
            ) : null}
          </table>
        </div>
      )}
    </>
  );
};

export default Summary;
